import React, { useContext, useEffect, useState } from "react";
import { alpha, Box, Stack } from "@mui/material";
import AuthContext from "../context/AuthContext";
import Header from "../components/Header";
import SideMenu from "../components/SideMenu";
import AppNavbar from "../components/AppNavbar";
import { ThemeContext } from "../theme/AppTheme";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const auth = useContext(AuthContext)
  const { isReady } = useContext(AuthContext)

  const themeContext = useContext(ThemeContext); // #POW-35
  const { localeValue, setLocalizations } = themeContext; // #POW-35

  useEffect(() => {
    if (isReady) {
      if (auth.user && auth.user.locale) {
        setLocalizations(auth.user.locale) // #POW-35 set UI localization after login
      }
    }
  }, [isReady]);

  return (
    <Box sx={{ display: 'flex' }}>
        <SideMenu /> {/* #POW-5 */}
        <AppNavbar user={auth.user}/> {/* #POW-5 */}
        
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 14, md: 0 },
            }}
          > {/* #POW-5 */}
            <Header />
            {children}

          </Stack>
        </Box>
      </Box>
  );
};

export default DashboardLayout;
